import classes from "./Login.module.css";
import React, { useState } from "react";
import { Button, Input, Text } from "components/common";
import LoginOrSignupWith from "../LoginOrSignupWith/LoginOrSignupWith";
import AuthenticationModal from "components/common/AuthenticationModal/AuthenticationModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

const LoginPage = ({ setReload, setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Clear any previous errors
    setIsLoading(true);

    if (!username || !password) {
      setError("Please enter both username and password");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/signin`, {
        username,
        password,
      });

      if (response.data.token) {
        Cookies.set("token", response.data.token);
        setIsLoggedIn(true);
        setReload((prev) => prev + 1);
        navigate("/chat");
      }
    } catch (error) {
      console.error("Login failed:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.status === 401) {
          setError("Invalid username or password");
        } else if (error.response.status === 404) {
          setError("User not found");
        } else {
          setError("Login failed. Please try again later.");
        }
      } else if (error.request) {
        // The request was made but no response was received
        setError(
          "Unable to connect to server. Please check your internet connection."
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthenticationModal heading="Login to Teme UNS" onClose={() => navigate("/")}>
      <div className={classes.formContainer}>
        {/* <LoginOrSignupWith />
        <Text primitive500 sm className={classes.or} textCenter>
          or
        </Text> */}
        <div className={classes.inputWrapper}>
          {error && (
            <Text className={classes.errorText} sm>
              {error}
            </Text>
          )}
          <Input
            name="username"
            type="text"
            value={username}
            setValue={setUsername}
            placeholder="Username"
          />
          <Input
            name="password"
            type="password"
            value={password}
            setValue={setPassword}
            placeholder="Password"
          />

          <div className={classes.buttonContainer}>
            <Button
              wFull
              base
              onClick={handleLogin}
              disabled={isLoading}
              loading={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </Button>
            <Button
              transparent
              to="/forgot-password"
              className={classes.button}
              base
            >
              Forgot Password?
            </Button>
          </div>
        </div>
      </div>{" "}
      <div className={classes.bottomBar}>
        <Text PrimitiveTransparent60 sm textCenter>
          Don't have any account?
        </Text>
        <Button transparent to="/sign-up" className={classes.button}>
          Sign up
        </Button>
      </div>
    </AuthenticationModal>
  );
};

export default LoginPage;
